// Ordered, publicly-visible room images: primary first, hidden excluded.
export function visibleRoomImages(room) {
  const imgs = (room && room.images) || [];
  const hidden = new Set((room && room.hidden_images) || []);
  const visible = imgs.filter((u) => !hidden.has(u));
  const primary = room && room.primary_image;
  if (primary && visible.includes(primary)) {
    return [primary, ...visible.filter((u) => u !== primary)];
  }
  return visible;
}
